import React from 'react';

import UFOLoadHold from '@atlaskit/react-ufo/load-hold';

import useUfoLoadingStatus from '../../hooks/useUfoLoadingStatus';

export const UFOLoadingStatusTracker = ({
	loadingStatus,
}: {
	loadingStatus?: string;
}): React.JSX.Element => {
	const extendedLoadingStatus = useUfoLoadingStatus(loadingStatus);

	if (extendedLoadingStatus) {
		return (
			<UFOLoadHold
				name={`loadingStatus_${extendedLoadingStatus}`}
				key={`loadingStatus_${extendedLoadingStatus}`}
			/>
		);
	} else {
		return <></>;
	}
};
